export const organizationConstants = {
  UPDATE_ORGANIZATION_REQUEST: 'UPDATE_ORGANIZATION_REQUEST',
  UPDATE_ORGANIZATION_SUCCESS: 'UPDATE_ORGANIZATION_SUCCESS',
  UPDATE_ORGANIZATION_FAILURE: 'UPDATE_ORGANIZATION_FAILURE',

  GET_ORGANIZATION_BY_USER_FAILURE: 'GET_ORGANIZATION_BY_USER_FAILURE',
  GET_ORGANIZATION_BY_USER_REQUEST: 'GET_ORGANIZATION_BY_USER_REQUEST',
  GET_ORGANIZATION_BY_USER_SUCCESS: 'GET_ORGANIZATION_BY_USER_SUCCESS',

  GET_ORGANIZATION_DETAILS_REQUEST:'GET_ORGANIZATION_DETAILS_REQUEST',

  GET_ORGANIZATION_DETAILS_SUCCESS:'GET_ORGANIZATION_DETAILS_SUCCESS',
  GET_ORGANIZATION_USERS_SUCCESS:'GET_ORGANIZATION_USERS_SUCCESS',
  GET_ORGANIZATION_SUBS_SUCCESS:'GET_ORGANIZATION_SUBS_SUCCESS',
  GET_ORGANIZATION_SETTINGS_SUCCESS:'GET_ORGANIZATION_SETTINGS_SUCCESS',

  UPDATE_ORGANIZATION_DETAILS_SUCCESS:'UPDATE_ORGANIZATION_DETAILS_SUCCESS',
  UPDATE_ORGANIZATION_USERS_SUCCESS:'UPDATE_ORGANIZATION_USERS_SUCCESS',
  UPDATE_ORGANIZATION_SUBS_SUCCESS:'UPDATE_ORGANIZATION_SUBS_SUCCESS',
  UPDATE_ORGANIZATION_SETTINGS_SUCCESS:'UPDATE_ORGANIZATION_SETTINGS_SUCCESS',

  GET_ORGANIZATION_DETAILS_FAILURE:'GET_ORGANIZATION_DETAILS_FAILURE',

}
